import { QRVcard } from "./qr-vcard";
export { QRVcard };
